import React from "react";
import { Dropdown } from "reactstrap";

export class ToggableDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  render() {
    const { visible } = this.state;

    return (
      <Dropdown
        className={this.props.className}
        isOpen={visible}
        toggle={() => this.setState({ visible: !visible })}
      >
        {this.props.children}
      </Dropdown>
    );
  }
}

export {
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from "reactstrap";


// WEBPACK FOOTER //
// ./src/components/Table/Dropdown.js